/*
*   NOTE:
*   Needed to move client to its own file because of production build requirements.
*   Example repo with the solution: https://github.com/jlengstorf/gatsby-with-apollo/blob/master/src/apollo/client.js
*/
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

export default new ApolloClient({
    link: new HttpLink({
        uri: "https://peterwiebe-server.now.sh",
        fetchOptions: {
            mode: 'cors',
        },
    }),
    cache: new InMemoryCache(),
})
